export const DEPARTMENTS = [
  { key: "men", label: "Men" },
  { key: "women", label: "Women" },
  { key: "kids", label: "Kids" },
];

export const SUBCATEGORIES = {
  men: ["T-Shirts", "Shirts", "Polo Shirts", "Jeans", "Trousers", "Chinos", "Jackets", "Hoodies", "Sweatshirts", "Blazers", "Suits", "Ethnic Wear", "Activewear", "Footwear", "Accessories"],
  women: ["Tops", "Dresses", "Shirts", "T-Shirts", "Jeans", "Trousers", "Skirts", "Jackets", "Blazers", "Sweaters", "Co-ords", "Ethnic Wear", "Sarees", "Kurtas", "Lehengas", "Activewear", "Footwear", "Handbags", "Accessories"],
  kids: ["T-Shirts", "Shirts", "Dresses", "Jeans", "Trousers", "Shorts", "Jackets", "Ethnic Wear", "Party Wear", "Sleepwear", "Activewear", "Footwear", "Accessories"],
};

export const ITEM_TYPES = ["T-Shirt", "Shirt", "Jeans", "Dress", "Jacket", "Trouser", "Sweatshirt", "Hoodie", "Blazer", "Saree", "Kurta", "Kidswear", "Footwear", "Bag", "Other"];

export const CONDITIONS = [
  { key: "Like New", desc: "Worn once or twice. No visible signs of wear. Tags may still be attached." },
  { key: "Excellent", desc: "Gently used with no noticeable flaws, stains or damage." },
  { key: "Very Good", desc: "Light signs of wear. Minor fading or pilling, nothing structural." },
  { key: "Good", desc: "Clearly worn but well cared for. Small imperfections are present." },
  { key: "Fair", desc: "Visible wear, fading or minor damage. Lower Cloth Cash offers expected." },
];

export const PHOTO_SLOTS = [
  { key: "front", label: "Front photograph", required: true },
  { key: "back", label: "Back photograph", required: true },
  { key: "brand_label", label: "Brand label photograph", required: true },
  { key: "size_label", label: "Size label photograph", required: true },
  { key: "fabric_label", label: "Fabric / material label (if available)", required: false },
  { key: "damage", label: "Any visible damage, stain, tear or wear", required: false },
];

export const TRADE_IN_STEPS = ["Submitted", "Under Review", "More Information Required", "Approved", "Rejected", "Cloth Cash Offer Ready", "Customer Accepted", "Pickup Scheduled", "Received", "Final Inspection", "Cloth Cash Issued", "Trade-In Completed"];
